import React, { useState } from "react";
import styles from "./auth.module.css";
import { images,icons } from "assets";
import Text from "Components/shared/text";
import FormControl from "Components/shared/control";
import { InputWithAdornment } from "Components/shared/inputs";
import Button from "Components/shared/button";
import { Link, useNavigate } from "react-router-dom";
import useForm from "hooks/useForm";
import validateLogin from "utils/validators/login";
import { forgotPasswordAction } from "services/authService";
import { SuccessModal } from "Components/shared/successful/SuccessModal";
import { ErrorModal } from "Components/shared/successful/ErrorModal";
const ForgotPassword = () => {
    const navigate = useNavigate();
    const [errorModal, setErrorModal] = useState("");
    const [successModal, setSuccessModal] = useState("");
   
    const getPassword = async(values, {setIsSubmitting}) => {
        try{
            setErrorModal(false);
            const {data:{data, status, message}} = await forgotPasswordAction(values.email)
                console.log(data, status, message)
            if(status === "Ok"){
                setSuccessModal(message);
                
                
            }
        }
        catch(err){
            setErrorModal(err.message);
        }
        finally{
            setIsSubmitting(false)
        }
    }
    const {handleUpdate, values, errors, touched, isSubmitting, handleSubmit} = useForm({
        initialState:{
            email:""
        },
        onSubmitHandler: getPassword,
        validate: validateLogin
    })
    return (
        <div className={styles.root}>
             <div className={styles.Password}>
                <div >
                    <img src={icons.logo} alt="company logo" />
                </div>
                 <div className={styles.FormContainer} style={{alignItems:"flex-start"}} >
                    <Text tag="h1" style={{fontWeight:800, padding:"0 20px"}} variant="xxl">Forgot Password?</Text>
                    <Text color="secondary" variant="md" style={{padding:"0 20px"}}>Please type in the email address linked to your 
                                Cowrie Exchange account to reset your password.
                        </Text>
                    <form className={styles.Form} onSubmit={handleSubmit}>
                        <FormControl label="Email Address" fullWidth 
                        error={errors.email && touched.email && errors.email}
                        name="email" id="email" >
                            <InputWithAdornment type="email" fullWidth
                            {...handleUpdate()}
                            value={values.email}
                            right={<img src={icons.envelope} alt="mail" />}
                            placeholder="Enter your email address" />
                        </FormControl>
                        
                        <div className={styles.ForgotPassword}>
                            <Text color="primary" variant="sm">
                                Remember Password? <Link to="/auth" style={{color:"var(--secondary-color)"}}>Back to Sign in</Link>
                            </Text>
                        </div>
                        <FormControl fullWidth >
                            <Button fullWidth 
                            disabled={!!errors.email}

                            loading={isSubmitting} label="Reset" type="submit"/>
                        </FormControl>
                        <SuccessModal setOpenModal={setSuccessModal} openModal={!!successModal} message={successModal} route="/auth" />
                        <ErrorModal setErrorModal={setErrorModal} openModal={!!errorModal} message={errorModal}  />
                    </form>
                </div>
            </div>
            <div className={styles.WaterContainer}>
                <img src={images.watermark} alt="watermark" className={styles.Watermark}/>
            </div>
        </div>
    );
};

export default ForgotPassword;